/* Free car-valuation wizard (Saudi market). One question per screen; the
   last step collects an email or phone, then the worker returns the
   estimate (a single Gemini call with a Saudi-market prompt) and stores
   the lead. Contact details never go to the model. Same tiny i18n engine
   as the other standalone Cardiagnos pages. */
(function(){
  'use strict';

  var CFG = window.CARDIAGNOS_CV_CONFIG || {};
  var LANG_KEY = 'vir_lang';
  var LANGS = ['en', 'sv', 'ar'];
  // Official Saudi Riyal symbol (SAMA) -- shown for SAR estimates; SEK stays text.
  var RIYAL_SVG = '<svg class="riyal-mark" viewBox="0 0 1124.14 1256.39" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M699.62,1113.02h0c-20.06,44.48-33.32,92.75-38.4,143.37l424.51-90.24c20.06-44.47,33.31-92.75,38.4-143.37l-424.51,90.24Z"/><path d="M1085.73,895.8c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.33v-135.2l292.27-62.11c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.27V66.13c-50.67,28.45-95.67,66.32-132.25,110.99v403.35l-132.25,28.11V0c-50.67,28.44-95.67,66.32-132.25,110.99v525.69l-295.91,62.88c-20.06,44.47-33.33,92.75-38.42,143.37l334.33-71.05v170.26l-358.3,76.14c-20.06,44.47-33.32,92.75-38.4,143.37l375.04-79.7c30.53-6.35,56.77-24.4,73.83-49.24l68.78-101.97v-.02c7.14-10.55,11.3-23.27,11.3-36.97v-149.98l132.25-28.11v270.4l424.53-90.28Z"/></svg>';

  var I18N = {
    en: {
      brandName: 'SightCore',
      brandTagline: "We see what others don't.",
      eyebrow: 'FREE CAR VALUATION',
      introTitle: "What's your car worth today?",
      introLede: 'Answer a few quick questions and get an estimated market price for your car. Free — no account needed.',
      introStart: 'Start',
      introFine: 'Takes about 30 seconds.',
      qSellingIntent: 'Are you thinking about selling this car?',
      sellingIntentLabel: "Yes, I'm interested in selling it",
      sellingIntentFine: "Just for us — it won't change your estimate.",
      qMake: "What's the make?",
      makeOther: 'Other',
      phMakeOther: 'Type the make',
      qModel: 'Which model?',
      phModel: 'e.g. Camry, Land Cruiser, Accent',
      qYear: 'What model year?',
      yearOlder: '2000 or older',
      qTransmission: 'Transmission?',
      txAuto: 'Automatic', txManual: 'Manual',
      qMileage: 'Roughly how many kilometres?',
      kmUnit: 'km', kmPlus: '+',
      phMileageExact: 'or type exact km',
      qCondition: 'What condition is it in?',
      condExcT: 'Excellent', condExcD: 'Clean history, no accidents, dealer-serviced.',
      condGoodT: 'Good', condGoodD: 'Normal used car, minor wear, runs well.',
      condFairT: 'Fair', condFairD: 'Needs paint or mechanical work.',
      qSpec: 'Which spec is it?',
      specGccT: 'GCC / Saudi (خليجي)', specGccD: 'Sold new in the Gulf.',
      specAmT: 'American (أمريكي)', specAmD: 'Imported from the US.',
      specOtherT: 'Other / imported', specOtherD: 'Canadian, European or unknown origin.',
      qCity: 'Where will you sell it?',
      cityRiyadh: 'Riyadh', cityJeddah: 'Jeddah', cityDammam: 'Dammam / Khobar', cityOther: 'Other cities',
      cityMakkah: 'Makkah', cityMadinah: 'Madinah',
      cityStockholm: 'Stockholm', cityGoteborg: 'Gothenburg', cityMalmo: 'Malmö',
      cityKhobar: 'Khobar', cityDhahran: 'Dhahran', cityTaif: 'Taif', cityTabuk: 'Tabuk',
      cityBuraidah: 'Buraidah', cityKhamisMushait: 'Khamis Mushait', cityAbha: 'Abha', cityNajran: 'Najran',
      cityHail: 'Hail', cityJubail: 'Jubail', cityYanbu: 'Yanbu', cityAlKharj: 'Al Kharj',
      cityQatif: 'Qatif', cityHafarAlBatin: 'Hafar Al-Batin', cityJazan: 'Jazan', cityArar: 'Arar',
      citySakaka: 'Sakaka', cityAlBahah: 'Al Bahah', cityUnaizah: 'Unaizah', cityRass: 'Rass',
      cityQunfudhah: 'Al Qunfudhah', cityRabigh: 'Rabigh', cityMajmaah: 'Al Majma’ah', cityWadiDawasir: 'Wadi ad-Dawasir',
      cityUppsala: 'Uppsala', cityVasteras: 'Västerås', cityOrebro: 'Örebro', cityLinkoping: 'Linköping',
      cityHelsingborg: 'Helsingborg', cityJonkoping: 'Jönköping', cityNorrkoping: 'Norrköping', cityLund: 'Lund',
      cityUmea: 'Umeå', cityGavle: 'Gävle', cityBoras: 'Borås', citySodertalje: 'Södertälje',
      cityEskilstuna: 'Eskilstuna', cityHalmstad: 'Halmstad', cityVaxjo: 'Växjö', cityKarlstad: 'Karlstad',
      citySundsvall: 'Sundsvall', cityTrollhattan: 'Trollhättan', cityOstersund: 'Östersund', cityFalun: 'Falun',
      citySkovde: 'Skövde', cityKalmar: 'Kalmar', cityKristianstad: 'Kristianstad', cityKarlskrona: 'Karlskrona',
      cityLulea: 'Luleå', cityUddevalla: 'Uddevalla', cityOrnskoldsvik: 'Örnsköldsvik',
      qContact: 'Where should we send your estimate?',
      contactLede: "Enter an email or phone number to see your car's estimated value. It's free.",
      phEmail: 'Email address', phPhone: '05X XXX XXXX', or: 'or',
      contactSubmit: 'Show my estimate',
      contactFine: 'We use your email or phone only to show and save your estimate. The estimate is made by an AI model from your car\'s details only; your contact details are never sent to it. See our <a href="/pages/privacy-policy">Privacy Policy</a>.',
      consentLabel: 'Yes, email me once with a tip on booking an inspection for this car. You can unsubscribe at any time.',
      dealerConsentLabel: 'Yes, car dealers who subscribe to Cardiagnos may contact me about buying my car. They will see my car\u2019s details, my estimate and my email or phone number. I can withdraw this at any time by writing to us.',
      errContact: 'Enter a valid email or phone number.',
      loadingTitle: "Estimating your car's value…",
      loadingSub: 'Checking how this model trades right now.',
      resultEyebrow: 'ESTIMATED MARKET VALUE',
      sar: 'SAR',
      rangeLow: 'Low', rangeHigh: 'High',
      confHigh: 'High confidence', confMedium: 'Medium confidence', confLow: 'Lower confidence — uncommon model',
      ctaLine: 'Condition is the biggest swing in that range. An independent inspection booked through Cardiagnos gives you a written record of the car\'s condition on the day.',
      ctaBook: 'Book an inspection', ctaAnother: 'Value another car',
      disclaimer: 'This is an automated estimate for guidance only, not a formal valuation or an offer to buy.',
      errorTitle: "Couldn't estimate a price right now.",
      errorTimeout: "This is taking longer than expected. Please try again.",
      errorRetry: 'Try again',
      back: 'Back', next: 'Continue',
    },
    ar: {
      brandName: 'عين الخلل',
      brandTagline: 'نرى ما لا يراه الآخرون.',
      eyebrow: 'تقدير سعر سيارتك مجانًا',
      introTitle: 'كم تساوي سيارتك اليوم؟',
      introLede: 'أجب عن أسئلة سريعة واحصل على سعر تقديري لسيارتك في السوق. مجانًا — بدون إنشاء حساب.',
      introStart: 'ابدأ',
      introFine: 'يستغرق حوالي ٣٠ ثانية.',
      qSellingIntent: 'هل تفكر في بيع هذه السيارة؟',
      sellingIntentLabel: 'نعم، أنا مهتم ببيعها',
      sellingIntentFine: 'فقط لنا — لن يغيّر هذا تقديرك.',
      qMake: 'ما نوع السيارة (الماركة)؟',
      makeOther: 'أخرى',
      phMakeOther: 'اكتب اسم الماركة',
      qModel: 'ما الموديل؟',
      phModel: 'مثال: كامري، لاندكروزر، أكسنت',
      qYear: 'سنة الصنع؟',
      yearOlder: '٢٠٠٠ أو أقدم',
      qTransmission: 'ناقل الحركة؟',
      txAuto: 'أوتوماتيك', txManual: 'عادي (مانيوال)',
      qMileage: 'كم عدد الكيلومترات تقريبًا؟',
      kmUnit: 'كم', kmPlus: '+',
      phMileageExact: 'أو اكتب العدد بالضبط',
      qCondition: 'ما حالة السيارة؟',
      condExcT: 'ممتازة', condExcD: 'تاريخ نظيف، بدون حوادث، صيانة الوكالة.',
      condGoodT: 'جيدة', condGoodD: 'سيارة مستعملة عادية، استهلاك بسيط، تعمل جيدًا.',
      condFairT: 'متوسطة', condFairD: 'تحتاج إلى سمكرة أو إصلاح ميكانيكي.',
      qSpec: 'ما هي المواصفات؟',
      specGccT: 'خليجي / سعودي', specGccD: 'بيعت جديدة في الخليج.',
      specAmT: 'أمريكي', specAmD: 'مستوردة من أمريكا.',
      specOtherT: 'أخرى / مستوردة', specOtherD: 'كندي أو أوروبي أو مصدر غير معروف.',
      qCity: 'أين ستبيعها؟',
      cityRiyadh: 'الرياض', cityJeddah: 'جدة', cityDammam: 'الدمام / الخبر', cityOther: 'مدن أخرى',
      cityMakkah: 'مكة المكرمة', cityMadinah: 'المدينة المنورة',
      cityStockholm: 'ستوكهولم', cityGoteborg: 'يوتيبوري', cityMalmo: 'مالمو',
      cityKhobar: 'الخبر', cityDhahran: 'الظهران', cityTaif: 'الطائف', cityTabuk: 'تبوك',
      cityBuraidah: 'بريدة', cityKhamisMushait: 'خميس مشيط', cityAbha: 'أبها', cityNajran: 'نجران',
      cityHail: 'حائل', cityJubail: 'الجبيل', cityYanbu: 'ينبع', cityAlKharj: 'الخرج',
      cityQatif: 'القطيف', cityHafarAlBatin: 'حفر الباطن', cityJazan: 'جازان', cityArar: 'عرعر',
      citySakaka: 'سكاكا', cityAlBahah: 'الباحة', cityUnaizah: 'عنيزة', cityRass: 'الرس',
      cityQunfudhah: 'القنفذة', cityRabigh: 'رابغ', cityMajmaah: 'المجمعة', cityWadiDawasir: 'وادي الدواسر',
      qContact: 'إلى أين نرسل لك التقدير؟',
      contactLede: 'أدخل بريدًا إلكترونيًا أو رقم جوال لرؤية القيمة التقديرية لسيارتك. مجانًا.',
      phEmail: 'البريد الإلكتروني', phPhone: '05X XXX XXXX', or: 'أو',
      contactSubmit: 'أظهر التقدير',
      contactFine: 'نستخدم بريدك أو رقمك فقط لعرض التقدير وحفظه. يُعِد التقدير نموذج ذكاء اصطناعي من بيانات السيارة فقط، ولا تُرسل بيانات تواصلك إليه. راجع <a href="/ar/pages/privacy-policy">سياسة الخصوصية</a>.',
      consentLabel: 'نعم، راسلوني مرة واحدة بنصيحة لحجز فحص لهذه السيارة. يمكنني إلغاء الاشتراك في أي وقت.',
      dealerConsentLabel: 'نعم، يجوز لتجار السيارات المشتركين في Cardiagnos التواصل معي بشأن شراء سيارتي. سيرون بيانات سيارتي وتقييمي وبريدي الإلكتروني أو رقم هاتفي. يمكنني سحب هذه الموافقة في أي وقت بمراسلتكم.',
      errContact: 'أدخل بريدًا إلكترونيًا صحيحًا أو رقم جوال صحيحًا.',
      loadingTitle: 'جارٍ تقدير قيمة سيارتك…',
      loadingSub: 'نتحقق من أسعار هذا الموديل في السوق الآن.',
      resultEyebrow: 'القيمة السوقية التقديرية',
      sar: 'ريال',
      rangeLow: 'الأدنى', rangeHigh: 'الأعلى',
      confHigh: 'ثقة عالية', confMedium: 'ثقة متوسطة', confLow: 'ثقة أقل — موديل غير شائع',
      ctaLine: 'الحالة هي أكبر عامل يحرّك هذا النطاق. الفحص المستقل الذي تحجزه عبر عين الخلل يمنحك سجلًّا مكتوبًا لحالة السيارة يوم الفحص.',
      ctaBook: 'احجز فحصًا', ctaAnother: 'قدّر سيارة أخرى',
      disclaimer: 'هذا تقدير آلي للاسترشاد فقط، وليس تقييمًا رسميًا ولا عرض شراء.',
      errorTitle: 'تعذّر تقدير السعر الآن.',
      errorTimeout: 'يستغرق هذا وقتًا أطول من المتوقع. يرجى المحاولة مرة أخرى.',
      errorRetry: 'حاول مرة أخرى',
      back: 'رجوع', next: 'متابعة',
    },
    sv: {
      brandName: 'Klarsikt',
      brandTagline: 'Vi ser det andra missar.',
      eyebrow: 'GRATIS BILVÄRDERING',
      introTitle: 'Vad är din bil värd idag?',
      introLede: 'Svara på några snabba frågor och få ett uppskattat marknadspris för din bil. Gratis — inget konto krävs.',
      introStart: 'Börja',
      introFine: 'Tar ungefär 30 sekunder.',
      qSellingIntent: 'Funderar du på att sälja den här bilen?',
      sellingIntentLabel: 'Ja, jag är intresserad av att sälja',
      sellingIntentFine: 'Bara för oss — det ändrar inte din värdering.',
      qMake: 'Vilket märke?',
      makeOther: 'Annat',
      phMakeOther: 'Skriv märket',
      qModel: 'Vilken modell?',
      phModel: 't.ex. V70, Golf, A4',
      qYear: 'Vilket modellår?',
      yearOlder: '2000 eller äldre',
      qTransmission: 'Växellåda?',
      txAuto: 'Automat', txManual: 'Manuell',
      qMileage: 'Ungefär hur många kilometer?',
      kmUnit: 'km', kmPlus: '+',
      phMileageExact: 'eller skriv exakt km',
      qCondition: 'I vilket skick är den?',
      condExcT: 'Utmärkt', condExcD: 'Ren historik, inga olyckor, märkesservad.',
      condGoodT: 'Bra', condGoodD: 'Normal begagnad bil, mindre slitage, går bra.',
      condFairT: 'Okej', condFairD: 'Behöver lack eller mekanisk åtgärd.',
      qSpec: 'Vilken specifikation?',
      specGccT: 'GCC / Saudi', specGccD: 'Såld ny i Gulfen.',
      specAmT: 'Amerikansk', specAmD: 'Importerad från USA.',
      specOtherT: 'Annan / importerad', specOtherD: 'Kanadensisk, europeisk eller okänt ursprung.',
      qCity: 'Var ska du sälja den?',
      cityRiyadh: 'Riyadh', cityJeddah: 'Jeddah', cityDammam: 'Dammam / Khobar', cityOther: 'Fler städer',
      cityMakkah: 'Mecka', cityMadinah: 'Medina',
      cityStockholm: 'Stockholm', cityGoteborg: 'Göteborg', cityMalmo: 'Malmö',
      cityUppsala: 'Uppsala', cityVasteras: 'Västerås', cityOrebro: 'Örebro', cityLinkoping: 'Linköping',
      cityHelsingborg: 'Helsingborg', cityJonkoping: 'Jönköping', cityNorrkoping: 'Norrköping', cityLund: 'Lund',
      cityUmea: 'Umeå', cityGavle: 'Gävle', cityBoras: 'Borås', citySodertalje: 'Södertälje',
      cityEskilstuna: 'Eskilstuna', cityHalmstad: 'Halmstad', cityVaxjo: 'Växjö', cityKarlstad: 'Karlstad',
      citySundsvall: 'Sundsvall', cityTrollhattan: 'Trollhättan', cityOstersund: 'Östersund', cityFalun: 'Falun',
      citySkovde: 'Skövde', cityKalmar: 'Kalmar', cityKristianstad: 'Kristianstad', cityKarlskrona: 'Karlskrona',
      cityLulea: 'Luleå', cityUddevalla: 'Uddevalla', cityOrnskoldsvik: 'Örnsköldsvik',
      qContact: 'Vart ska vi skicka din värdering?',
      contactLede: 'Ange en e-post eller ett telefonnummer för att se bilens uppskattade värde. Det är gratis.',
      phEmail: 'E-postadress', phPhone: '07X-XXX XX XX', or: 'eller',
      contactSubmit: 'Visa min värdering',
      contactFine: 'Vi använder din e-post eller ditt telefonnummer bara för att visa och spara värderingen. Värderingen görs av en AI-modell utifrån bilens uppgifter; dina kontaktuppgifter skickas aldrig dit. Läs vår <a href="/sv/pages/privacy-policy">integritetspolicy</a>.',
      consentLabel: 'Ja, mejla mig en gång med ett tips om att boka en besiktning av bilen. Jag kan avregistrera mig när som helst.',
      dealerConsentLabel: 'Ja, bilhandlare som prenumererar hos Cardiagnos får kontakta mig om att köpa min bil. De ser uppgifter om min bil, min värdering och min e-post eller mitt telefonnummer. Jag kan när som helst ta tillbaka detta genom att skriva till oss.',
      errContact: 'Ange en giltig e-post eller ett giltigt telefonnummer.',
      loadingTitle: 'Uppskattar bilens värde…',
      loadingSub: 'Kollar hur den här modellen säljs just nu.',
      resultEyebrow: 'UPPSKATTAT MARKNADSVÄRDE',
      sar: 'SAR',
      rangeLow: 'Lågt', rangeHigh: 'Högt',
      confHigh: 'Hög säkerhet', confMedium: 'Medelhög säkerhet', confLow: 'Lägre säkerhet — ovanlig modell',
      ctaLine: 'Skicket är den största variabeln i intervallet. En fristående inspektion som bokas via Cardiagnos ger dig en skriftlig redogörelse för bilens skick på dagen.',
      ctaBook: 'Boka en besiktning', ctaAnother: 'Värdera en annan bil',
      disclaimer: 'Detta är en automatisk uppskattning endast som vägledning, inte en formell värdering eller ett köperbjudande.',
      errorTitle: 'Kunde inte uppskatta ett pris just nu.',
      errorTimeout: 'Det här tar längre tid än väntat. Försök igen.',
      errorRetry: 'Försök igen',
      back: 'Tillbaka', next: 'Fortsätt',
    },
  };

  // Makes / models are market-specific: Swedish visitors (locale 'sv') get
  // the Swedish market, everyone else Saudi Arabia.
  var MAKES_SA = ['Toyota', 'Hyundai', 'Nissan', 'Lexus', 'Kia', 'Chevrolet', 'Ford', 'GMC',
                  'Honda', 'Mercedes-Benz', 'BMW', 'Mitsubishi', 'Mazda', 'Land Rover'];
  var MAKES_SE = ['Volvo', 'Volkswagen', 'Audi', 'BMW', 'Toyota', 'Kia', 'Mercedes-Benz',
                  'Škoda', 'Nissan', 'Ford', 'Tesla', 'Peugeot', 'Renault', 'Hyundai'];
  var MODELS_SA = {
    'Toyota': ['Camry', 'Corolla', 'Land Cruiser', 'Hilux', 'Yaris', 'Prado', 'RAV4', 'Avalon', 'Fortuner', 'Innova', 'Hiace'],
    'Hyundai': ['Accent', 'Elantra', 'Sonata', 'Tucson', 'Santa Fe', 'Creta', 'Azera', 'Staria'],
    'Nissan': ['Patrol', 'Altima', 'Sunny', 'X-Trail', 'Sentra', 'Maxima', 'Kicks', 'Pathfinder'],
    'Lexus': ['ES', 'LS', 'GS', 'RX', 'LX', 'IS', 'NX', 'GX'],
    'Kia': ['Cerato', 'Optima', 'Sportage', 'Sorento', 'Rio', 'Carnival', 'Pegas', 'K5'],
    'Chevrolet': ['Tahoe', 'Silverado', 'Malibu', 'Impala', 'Captiva', 'Camaro', 'Suburban', 'Traverse'],
    'Ford': ['F-150', 'Taurus', 'Explorer', 'Edge', 'Expedition', 'Mustang', 'Ranger'],
    'GMC': ['Yukon', 'Sierra', 'Acadia', 'Terrain'],
    'Honda': ['Accord', 'Civic', 'CR-V', 'Pilot', 'City', 'HR-V'],
    'Mercedes-Benz': ['C-Class', 'E-Class', 'S-Class', 'GLE', 'GLC', 'CLA'],
    'BMW': ['3 Series', '5 Series', '7 Series', 'X5', 'X3', 'X6'],
    'Mitsubishi': ['Lancer', 'Pajero', 'L200', 'Attrage', 'ASX', 'Xpander'],
    'Mazda': ['3', '6', 'CX-5', 'CX-9', 'CX-3', 'CX-30'],
    'Land Rover': ['Range Rover', 'Range Rover Sport', 'Discovery', 'Defender', 'Evoque'],
  };
  var MODELS_SE = {
    'Volvo': ['V70', 'V60', 'V90', 'XC60', 'XC90', 'V40', 'S60', 'XC40', 'S90', 'V50'],
    'Volkswagen': ['Golf', 'Passat', 'Tiguan', 'Polo', 'Touran', 'T-Roc', 'Caddy', 'ID.4', 'Up'],
    'Audi': ['A4', 'A6', 'A3', 'Q5', 'Q3', 'A5', 'Q7', 'A1'],
    'BMW': ['3-serie', '5-serie', 'X3', 'X5', '1-serie', '2-serie', 'X1'],
    'Toyota': ['Corolla', 'RAV4', 'Yaris', 'Auris', 'Aygo', 'C-HR', 'Prius', 'Avensis'],
    'Kia': ['Ceed', 'Sportage', 'Niro', 'Rio', 'Optima', 'Picanto'],
    'Mercedes-Benz': ['C-Klass', 'E-Klass', 'A-Klass', 'GLC', 'CLA', 'B-Klass'],
    'Škoda': ['Octavia', 'Superb', 'Fabia', 'Kodiaq', 'Karoq', 'Scala'],
    'Nissan': ['Qashqai', 'Leaf', 'X-Trail', 'Micra', 'Juke'],
    'Ford': ['Focus', 'Kuga', 'Fiesta', 'Mondeo', 'C-Max'],
    'Tesla': ['Model 3', 'Model Y', 'Model S', 'Model X'],
    'Peugeot': ['308', '208', '3008', '508', '2008'],
    'Renault': ['Clio', 'Mégane', 'Captur', 'Kadjar', 'Zoe'],
    'Hyundai': ['i30', 'Tucson', 'Kona', 'i20', 'Santa Fe', 'Ioniq'],
  };
  function market(){ return (typeof currentLang !== 'undefined' && currentLang === 'sv') ? 'se' : 'sa'; }
  function makesList(){ return market() === 'se' ? MAKES_SE : MAKES_SA; }
  function modelsFor(make){ var m = market() === 'se' ? MODELS_SE : MODELS_SA; return (make && m[make]) || []; }

  var currentLang = (CFG.storefrontLocale === 'ar' || CFG.storefrontLocale === 'sv') ? CFG.storefrontLocale : 'en';
  try{ var s = localStorage.getItem(LANG_KEY); if(LANGS.indexOf(s) !== -1) currentLang = s; }catch(e){}
  // A language in the address (cardiagons.com/ar, /sv) wins over a saved
  // choice -- someone opening the Arabic link should get Arabic -- and
  // becomes the saved choice from then on.
  var _urlLang = (location.pathname.match(/^\/(ar|sv|en)(\/|$)/) || [])[1];
  if(_urlLang){ currentLang = _urlLang; try{ localStorage.setItem(LANG_KEY, _urlLang); }catch(e){} }
  function d(){ return I18N[currentLang] || I18N.en; }
  function t(k){ var v = d()[k]; return (v == null) ? (I18N.en[k] || k) : v; }

  var appliedLocale = (CFG.storefrontLocale || 'en');
  function syncStorefrontLocale(){
    if(currentLang === appliedLocale) return;
    var form = document.getElementById('CvLocaleForm');
    var input = document.getElementById('cvLocaleCode');
    if(!form || !input) return;
    input.value = currentLang;
    appliedLocale = currentLang;
    try{
      fetch(form.getAttribute('action') || '/localization', {
        method: 'POST', credentials: 'same-origin', body: new FormData(form), headers: { 'Accept': 'text/html' }
      }).catch(function(){});
    }catch(e){}
  }

  // ---- state ----
  var STEPS = ['intro', 'sellingIntent', 'make', 'model', 'year', 'transmission', 'mileage', 'condition', 'spec', 'city', 'contact'];
  var NEEDS_CONTINUE = { sellingIntent: 1, model: 1, mileage: 1 };
  var stepIdx = 0;
  var state = { sellingIntent: false, make: '', makeRaw: '', model: '', year: 0, transmission: '', mileageKm: 120000, condition: '', specOrigin: '', city: '', cityKey: '' };
  var lastResult = null;

  var root = document.querySelector('.cv-root');
  var slides = {};
  document.querySelectorAll('.cv-slide').forEach(function(el){ slides[el.getAttribute('data-step')] = el; });
  var progressBar = document.getElementById('cvProgressBar');
  var backBtn = document.getElementById('cvBack');
  var nextBtn = document.getElementById('cvNext');

  function esc(x){ return String(x == null ? '' : x).replace(/[&<>"']/g, function(c){ return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); }
  function fmt(n){ try{ return Number(n).toLocaleString('en-US'); }catch(e){ return String(n); } }

  // ---- translations ----
  function applyTranslations(){
    document.querySelectorAll('[data-i18n]').forEach(function(el){
      var v = t(el.getAttribute('data-i18n'));
      if(v != null) el.textContent = v;
    });
    document.querySelectorAll('[data-i18n-html]').forEach(function(el){
      var v = t(el.getAttribute('data-i18n-html'));
      if(v != null) el.innerHTML = v;
    });
    document.querySelectorAll('[data-i18n-ph]').forEach(function(el){
      var v = t(el.getAttribute('data-i18n-ph'));
      if(v != null) el.setAttribute('placeholder', v);
    });
  }

  function setLang(lang){
    currentLang = LANGS.indexOf(lang) !== -1 ? lang : 'en';
    try{ localStorage.setItem(LANG_KEY, currentLang); }catch(e){}
    // Keep the address in step (/ar, /sv, none for English) so a reload
    // doesn't switch back to the language in the old URL.
    try{ var _p = location.pathname.replace(/^\/(ar|sv|en)(?=\/|$)/, ''); if(_p === '/') _p = ''; history.replaceState(null, '', (currentLang === 'en' ? '' : '/' + currentLang) + (_p || (currentLang === 'en' ? '/' : '')) + location.search + location.hash); }catch(e){}
    if(root){
      root.setAttribute('dir', currentLang === 'ar' ? 'rtl' : 'ltr');
      root.setAttribute('lang', currentLang);
    }
    document.querySelectorAll('[data-lang-opt]').forEach(function(el){
      var on = el.getAttribute('data-lang-opt') === currentLang;
      el.classList.toggle('active', on);
      if(el.tagName === 'BUTTON') el.setAttribute('aria-pressed', String(on));
    });
    applyTranslations();
    buildMakeGrid();
    buildYearGrid();
    buildCityGrid();
    renderModelChips();
    updateMileageOut();
    if(slides.result && slides.result.classList.contains('is-active') && lastResult) paintResult(lastResult, true);
    syncStorefrontLocale();
  }
  document.querySelectorAll('[data-lang-opt]').forEach(function(el){
    el.addEventListener('click', function(){ setLang(el.getAttribute('data-lang-opt')); });
  });

  // ---- grids ----
  function buildMakeGrid(){
    var g = document.getElementById('cvMakeGrid');
    if(!g) return;
    var html = makesList().map(function(m){
      return '<button type="button" class="cv-opt' + (state.make === m ? ' is-selected' : '') + '" data-make="' + esc(m) + '">' + esc(m) + '</button>';
    }).join('');
    html += '<button type="button" class="cv-opt' + (state.make === '__other__' ? ' is-selected' : '') + '" data-make="__other__">' + esc(t('makeOther')) + '</button>';
    g.innerHTML = html;
    g.querySelectorAll('[data-make]').forEach(function(b){
      b.addEventListener('click', function(){ chooseMake(b.getAttribute('data-make')); });
    });
  }
  function chooseMake(m){
    var otherWrap = document.getElementById('cvMakeOtherWrap');
    if(m === '__other__'){
      state.make = '__other__';
      buildMakeGrid();
      if(otherWrap){ otherWrap.hidden = false; var i = document.getElementById('cvMakeOther'); if(i){ i.value = state.makeRaw || ''; i.focus(); } }
      updateNav();
      return;
    }
    state.make = m; state.makeRaw = m;
    if(otherWrap) otherWrap.hidden = true;
    buildMakeGrid();
    renderModelChips();
    autoAdvance();
  }
  var makeOtherInput = document.getElementById('cvMakeOther');
  if(makeOtherInput){
    makeOtherInput.addEventListener('input', function(){ state.makeRaw = makeOtherInput.value.trim(); updateNav(); });
    makeOtherInput.addEventListener('keydown', function(e){ if(e.key === 'Enter' && canProceed()) go(1); });
  }

  function buildYearGrid(){
    var g = document.getElementById('cvYearGrid');
    if(!g) return;
    var now = new Date().getFullYear();
    var top = now + 1;
    var html = '';
    for(var y = top; y >= 2001; y--){
      html += '<button type="button" class="cv-opt' + (state.year === y ? ' is-selected' : '') + '" data-year="' + y + '">' + y + '</button>';
    }
    html += '<button type="button" class="cv-opt' + (state.year === 2000 ? ' is-selected' : '') + '" data-year="2000" style="grid-column:span 2">' + esc(t('yearOlder')) + '</button>';
    g.innerHTML = html;
    g.querySelectorAll('[data-year]').forEach(function(b){
      b.addEventListener('click', function(){ state.year = parseInt(b.getAttribute('data-year'), 10); buildYearGrid(); autoAdvance(); });
    });
  }

  // The handful of biggest cities per market show up front as one-tap
  // options; everything else lives behind the "Other cities" toggle
  // (CITY_MORE) so the quick-pick grid doesn't turn into an unscrollable
  // wall of buttons. Riyadh/Jeddah/Dammam were already here; Makkah and
  // Madinah were requested alongside them as equally prominent quick picks.
  var CITY_SETS = {
    sa: [['riyadh', 'cityRiyadh'], ['jeddah', 'cityJeddah'], ['makkah', 'cityMakkah'], ['madinah', 'cityMadinah'], ['dammam', 'cityDammam']],
    se: [['stockholm', 'cityStockholm'], ['goteborg', 'cityGoteborg'], ['malmo', 'cityMalmo']],
  };
  // Broad list of major Saudi/Swedish cities (not literally every town --
  // that would be hundreds of entries -- but every city someone would
  // reasonably expect to find here), revealed by tapping "Other cities".
  var CITY_MORE = {
    sa: [
      ['khobar', 'cityKhobar'], ['dhahran', 'cityDhahran'], ['taif', 'cityTaif'], ['tabuk', 'cityTabuk'],
      ['buraidah', 'cityBuraidah'], ['khamis_mushait', 'cityKhamisMushait'], ['abha', 'cityAbha'], ['najran', 'cityNajran'],
      ['hail', 'cityHail'], ['jubail', 'cityJubail'], ['yanbu', 'cityYanbu'], ['al_kharj', 'cityAlKharj'],
      ['qatif', 'cityQatif'], ['hafar_al_batin', 'cityHafarAlBatin'], ['jazan', 'cityJazan'], ['arar', 'cityArar'],
      ['sakaka', 'citySakaka'], ['al_bahah', 'cityAlBahah'], ['unaizah', 'cityUnaizah'], ['rass', 'cityRass'],
      ['qunfudhah', 'cityQunfudhah'], ['rabigh', 'cityRabigh'], ['majmaah', 'cityMajmaah'], ['wadi_dawasir', 'cityWadiDawasir'],
    ],
    se: [
      ['uppsala', 'cityUppsala'], ['vasteras', 'cityVasteras'], ['orebro', 'cityOrebro'], ['linkoping', 'cityLinkoping'],
      ['helsingborg', 'cityHelsingborg'], ['jonkoping', 'cityJonkoping'], ['norrkoping', 'cityNorrkoping'], ['lund', 'cityLund'],
      ['umea', 'cityUmea'], ['gavle', 'cityGavle'], ['boras', 'cityBoras'], ['sodertalje', 'citySodertalje'],
      ['eskilstuna', 'cityEskilstuna'], ['halmstad', 'cityHalmstad'], ['vaxjo', 'cityVaxjo'], ['karlstad', 'cityKarlstad'],
      ['sundsvall', 'citySundsvall'], ['trollhattan', 'cityTrollhattan'], ['ostersund', 'cityOstersund'], ['falun', 'cityFalun'],
      ['skovde', 'citySkovde'], ['kalmar', 'cityKalmar'], ['kristianstad', 'cityKristianstad'], ['karlskrona', 'cityKarlskrona'],
      ['lulea', 'cityLulea'], ['uddevalla', 'cityUddevalla'], ['ornskoldsvik', 'cityOrnskoldsvik'],
    ],
  };
  var cityMoreOpen = false;
  function wireCityButtons(g){
    g.querySelectorAll('[data-city]').forEach(function(b){
      b.addEventListener('click', function(){
        state.cityKey = b.getAttribute('data-city');
        state.city = b.getAttribute('data-label');
        cityMoreOpen = false;
        buildCityGrid();
        autoAdvance();
      });
    });
  }
  function buildCityGrid(){
    var g = document.getElementById('cvCityGrid');
    if(!g) return;
    var cities = CITY_SETS[market()] || CITY_SETS.sa;
    var html = cities.map(function(c){
      return '<button type="button" class="cv-opt' + (state.cityKey === c[0] ? ' is-selected' : '') + '" data-city="' + c[0] + '" data-label="' + esc(t(c[1])) + '">' + esc(t(c[1])) + '</button>';
    }).join('');
    // "Other cities" is a toggle, not a selectable value -- tapping it
    // reveals CITY_MORE's full grid below instead of immediately picking
    // a city (see buildCityMoreGrid()). The existing "Skip" button below
    // both grids remains the true "I'd rather not say" fallback.
    html += '<button type="button" class="cv-opt' + (cityMoreOpen ? ' is-selected' : '') + '" id="cvCityMoreBtn">' + esc(t('cityOther')) + '</button>';
    g.innerHTML = html;
    wireCityButtons(g);
    var moreBtn = document.getElementById('cvCityMoreBtn');
    if(moreBtn) moreBtn.addEventListener('click', function(){
      cityMoreOpen = !cityMoreOpen;
      buildCityGrid();
      buildCityMoreGrid();
    });
    buildCityMoreGrid();
  }
  function buildCityMoreGrid(){
    var wrap = document.getElementById('cvCityMoreWrap');
    var g = document.getElementById('cvCityMoreGrid');
    if(!wrap || !g) return;
    wrap.hidden = !cityMoreOpen;
    if(!cityMoreOpen) return;
    var cities = CITY_MORE[market()] || CITY_MORE.sa;
    g.innerHTML = cities.map(function(c){
      return '<button type="button" class="cv-opt' + (state.cityKey === c[0] ? ' is-selected' : '') + '" data-city="' + c[0] + '" data-label="' + esc(t(c[1])) + '">' + esc(t(c[1])) + '</button>';
    }).join('');
    wireCityButtons(g);
  }

  // ---- model ----
  var modelInput = document.getElementById('cvModel');
  var modelList = document.getElementById('cvModelList');
  function renderModelChips(){
    var wrap = document.getElementById('cvModelChips');
    var canonical = state.make && state.make !== '__other__' ? state.make : null;
    var list = modelsFor(canonical);
    if(modelList) modelList.innerHTML = list.map(function(m){ return '<option value="' + esc(m) + '"></option>'; }).join('');
    if(!wrap) return;
    wrap.innerHTML = list.slice(0, 6).map(function(m){
      return '<button type="button" class="cv-chip" data-model="' + esc(m) + '">' + esc(m) + '</button>';
    }).join('');
    wrap.querySelectorAll('[data-model]').forEach(function(b){
      b.addEventListener('click', function(){ state.model = b.getAttribute('data-model'); if(modelInput) modelInput.value = state.model; go(1); });
    });
  }
  if(modelInput){
    modelInput.addEventListener('input', function(){ state.model = modelInput.value.trim(); updateNav(); });
    modelInput.addEventListener('keydown', function(e){ if(e.key === 'Enter' && canProceed()){ e.preventDefault(); go(1); } });
  }

  // ---- transmission / condition / spec (cards) ----
  document.querySelectorAll('.cv-slide[data-step="transmission"] .cv-card').forEach(function(b){
    b.addEventListener('click', function(){ pickCard('transmission', 'transmission', b); });
  });
  document.querySelectorAll('.cv-slide[data-step="condition"] .cv-card').forEach(function(b){
    b.addEventListener('click', function(){ pickCard('condition', 'condition', b); });
  });
  document.querySelectorAll('.cv-slide[data-step="spec"] .cv-card').forEach(function(b){
    b.addEventListener('click', function(){ pickCard('spec', 'specOrigin', b); });
  });
  function pickCard(step, key, btn){
    state[key] = btn.getAttribute('data-value');
    slides[step].querySelectorAll('.cv-card').forEach(function(c){ c.classList.toggle('is-selected', c === btn); });
    autoAdvance();
  }

  // ---- mileage ----
  var mRange = document.getElementById('cvMileageRange');
  var mExact = document.getElementById('cvMileageExact');
  var mOut = document.getElementById('cvMileageOut');
  function updateMileageOut(){
    if(!mOut) return;
    var v = state.mileageKm;
    var atMax = mRange && v >= parseInt(mRange.max, 10);
    mOut.textContent = fmt(v) + (atMax ? t('kmPlus') : '') + ' ' + t('kmUnit');
  }
  if(mRange){
    mRange.value = state.mileageKm;
    mRange.addEventListener('input', function(){
      state.mileageKm = parseInt(mRange.value, 10);
      if(mExact) mExact.value = '';
      updateMileageOut();
    });
  }
  if(mExact){
    mExact.addEventListener('input', function(){
      var n = parseInt(mExact.value.replace(/[^\d]/g, ''), 10);
      if(Number.isFinite(n)){
        state.mileageKm = Math.min(2000000, n);
        if(mRange) mRange.value = Math.min(parseInt(mRange.max, 10), Math.max(0, n));
        updateMileageOut();
      }
    });
    mExact.addEventListener('keydown', function(e){ if(e.key === 'Enter'){ e.preventDefault(); go(1); } });
  }

  // ---- navigation ----
  function currentStep(){ return STEPS[stepIdx]; }
  function canProceed(){
    switch(currentStep()){
      case 'sellingIntent': return true;
      case 'make': return state.make === '__other__' ? !!state.makeRaw : !!state.make;
      case 'model': return !!state.model;
      case 'year': return !!state.year;
      case 'transmission': return !!state.transmission;
      case 'mileage': return true;
      case 'condition': return !!state.condition;
      case 'spec': return market() === 'se' ? true : !!state.specOrigin;
      // No more Skip button here (removed -- a city is now required, same
      // spirit as make/model/year being required) -- picking "Other
      // cities" itself doesn't count as a real answer, only an actual
      // city (quick-pick or from the expanded list) sets cityKey.
      case 'city': return !!state.cityKey;
      default: return true;
    }
  }
  function updateNav(){
    var step = currentStep();
    backBtn.hidden = (stepIdx <= 1);
    var showNext = !!NEEDS_CONTINUE[step] || (step === 'make' && state.make === '__other__');
    nextBtn.hidden = !showNext;
    nextBtn.disabled = !canProceed();
  }
  function showStep(name, dir){
    var target = slides[name];
    if(!target) return;
    var dealerWrap = document.getElementById('cvDealerWrap');
    if(dealerWrap){ var showDealer = name === 'contact' && !!state.sellingIntent && market() === 'sa'; dealerWrap.style.display = showDealer ? 'flex' : 'none'; if(!showDealer){ var dc = document.getElementById('cvDealerConsent'); if(dc) dc.checked = false; } }
    Object.keys(slides).forEach(function(k){
      var el = slides[k];
      if(el === target) return;
      if(el.classList.contains('is-active')){
        el.classList.remove('is-active');
        el.classList.add('is-leaving');
        setTimeout(function(){ el.classList.remove('is-leaving'); }, 340);
      }
    });
    target.classList.remove('is-leaving');
    // force reflow so the entry transition plays
    void target.offsetWidth;
    target.classList.add('is-active');
    updateProgress();
    updateNav();
    focusStep(name);
  }
  function focusStep(name){
    var el = slides[name];
    if(!el) return;
    var f = el.querySelector('input:not([type=range]), .cv-btn-primary');
    if(f && (name === 'model' || name === 'contact')) { try{ f.focus({ preventScroll: true }); }catch(e){} }
  }
  function updateProgress(){
    var step = currentStep();
    var contactPos = STEPS.indexOf('contact');
    var idx = STEPS.indexOf(step);
    var pct = 0;
    if(idx >= 1 && idx <= contactPos) pct = ((idx) / contactPos) * 100;
    if(step === 'loading' || step === 'result') pct = 100;
    if(progressBar) progressBar.style.width = Math.max(0, Math.min(100, pct)) + '%';
  }
  function go(delta){
    if(delta > 0 && !canProceed()) return;
    var ni = stepIdx + delta;
    // The Swedish market has no spec/origin question -- skip that step
    // whichever direction we're moving.
    if(STEPS[ni] === 'spec' && market() === 'se') ni += (delta >= 0 ? 1 : -1);
    if(ni < 1) ni = 1;
    if(ni >= STEPS.length){ submit(); return; }
    stepIdx = ni;
    showStep(currentStep());
  }
  function autoAdvance(){
    updateNav();
    setTimeout(function(){ if(canProceed()) go(1); }, 190);
  }
  backBtn.addEventListener('click', function(){ go(-1); });
  nextBtn.addEventListener('click', function(){ go(1); });
  document.querySelector('.cv-start').addEventListener('click', function(){ stepIdx = 1; showStep(currentStep()); });

  // ---- selling intent ----
  var sellingCheckbox = document.getElementById('cvSellingIntent');
  if(sellingCheckbox){
    sellingCheckbox.addEventListener('change', function(){ state.sellingIntent = sellingCheckbox.checked; });
  }

  // ---- submit ----
  var emailInput = document.getElementById('cvEmail');
  var phoneInput = document.getElementById('cvPhone');
  var contactErr = document.getElementById('cvContactErr');
  var submitBtn = document.getElementById('cvSubmit');

  function validContact(){
    var em = (emailInput.value || '').trim().toLowerCase();
    var ph = (phoneInput.value || '').trim();
    var emailOk = em && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em);
    var phoneOk = ph && ph.replace(/[^\d]/g, '').length >= 7;
    return { ok: emailOk || phoneOk, email: emailOk ? em : '', phone: phoneOk ? ph : '' };
  }
  if(submitBtn) submitBtn.addEventListener('click', submit);
  [emailInput, phoneInput].forEach(function(i){
    if(!i) return;
    i.addEventListener('keydown', function(e){ if(e.key === 'Enter'){ e.preventDefault(); submit(); } });
  });

  function submit(){
    var c = validContact();
    if(!c.ok){
      if(contactErr){ contactErr.textContent = t('errContact'); contactErr.hidden = false; }
      return;
    }
    if(contactErr) contactErr.hidden = true;
    stepIdx = STEPS.length; // past the wizard
    showStepRaw('loading');

    var makeOut = state.make === '__other__' ? state.makeRaw : state.make;

    // Hand the contact + vehicle over to the landing page's booking flow, so
    // "Book an inspection" on the result screen lands there with the email /
    // phone (and the car) already filled in. One-shot, read + consumed on the
    // landing page; expires after an hour.
    try{
      localStorage.setItem('cardiagnos_booking_prefill', JSON.stringify({
        email: c.email || '', phone: c.phone || '',
        make: makeOut || '', model: state.model || '', year: state.year ? String(state.year) : '',
        market: market(), ts: Date.now(),
      }));
    }catch(e){}
    var payload = {
      action: 'valuation_estimate',
      locale: currentLang,
      make: makeOut,
      model: state.model,
      year: state.year,
      transmission: state.transmission || undefined,
      mileageKm: state.mileageKm || undefined,
      condition: state.condition || undefined,
      specOrigin: state.specOrigin || undefined,
      city: state.city || undefined,
      sellingIntent: state.sellingIntent || undefined,
      contactEmail: c.email || undefined,
      contactPhone: c.phone || undefined,
      // GDPR/PDPL: follow-up emails only with this explicit, unticked-by-default opt-in.
      marketingConsent: !!(document.getElementById('cvConsent') && document.getElementById('cvConsent').checked && c.email),
      // Separate, explicit, unticked-by-default consent; only offered to people who said they want to sell.
      dealerConsent: !!(state.sellingIntent && document.getElementById('cvDealerConsent') && document.getElementById('cvDealerConsent').checked) || undefined,
    };
    // Real-user feedback: this could spin on the "loading" step forever
    // with no way out -- the worker's own Gemini call had no timeout
    // either (now fixed, see callGeminiValuation), but this side never had
    // one at all, so ANY stall anywhere in the round trip (not just a slow
    // model response) left the customer stuck with no error and no retry
    // button. 30s, a bit longer than the worker's own 20s Gemini timeout,
    // so the worker's own clean error message wins in the normal case and
    // this is purely a backstop for a genuinely stuck connection.
    var timedOut = false;
    var controller = (typeof AbortController !== 'undefined') ? new AbortController() : null;
    var timeoutId = setTimeout(function(){
      timedOut = true;
      if(controller) controller.abort();
    }, 30000);
    fetch(CFG.workerUrl, {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
      signal: controller ? controller.signal : undefined,
    })
      .then(function(res){ return res.json().then(function(data){ return { ok: res.ok, data: data }; }); })
      .then(function(r){
        clearTimeout(timeoutId);
        if(!r.ok || !r.data || !r.data.ok){
          throw new Error((r.data && r.data.error) || t('errorTitle'));
        }
        lastResult = r.data;
        lastResult._car = [state.year, makeOut, state.model].filter(Boolean).join(' ');
        showStepRaw('result');
        paintResult(lastResult, false);
      })
      .catch(function(err){
        clearTimeout(timeoutId);
        var et = document.getElementById('cvErrorText');
        var msg = timedOut ? t('errorTimeout') : ((err && err.message) || t('errorTitle'));
        if(et) et.textContent = msg;
        showStepRaw('error');
      });
  }

  function showStepRaw(name){
    Object.keys(slides).forEach(function(k){
      slides[k].classList.toggle('is-active', k === name);
      slides[k].classList.remove('is-leaving');
    });
    backBtn.hidden = true;
    nextBtn.hidden = true;
    if(progressBar) progressBar.style.width = '100%';
  }

  var errorRetry = document.getElementById('cvErrorRetry');
  if(errorRetry) errorRetry.addEventListener('click', function(){ stepIdx = STEPS.indexOf('contact'); showStep('contact'); });
  var restart = document.getElementById('cvRestart');
  if(restart) restart.addEventListener('click', function(){
    state.sellingIntent = false;
    state.model = ''; state.year = 0; state.transmission = ''; state.condition = ''; state.specOrigin = '';
    state.city = ''; state.cityKey = ''; state.mileageKm = 120000;
    if(sellingCheckbox) sellingCheckbox.checked = false;
    cityMoreOpen = false;
    if(modelInput) modelInput.value = '';
    if(mRange) mRange.value = 120000;
    if(mExact) mExact.value = '';
    if(emailInput) emailInput.value = '';
    if(phoneInput) phoneInput.value = '';
    lastResult = null;
    buildYearGrid(); buildCityGrid(); updateMileageOut();
    slides.transmission.querySelectorAll('.cv-card').forEach(function(c){ c.classList.remove('is-selected'); });
    slides.condition.querySelectorAll('.cv-card').forEach(function(c){ c.classList.remove('is-selected'); });
    slides.spec.querySelectorAll('.cv-card').forEach(function(c){ c.classList.remove('is-selected'); });
    stepIdx = 1; showStep(currentStep());
  });

  function paintResult(data, instant){
    var carEl = document.getElementById('cvResultCar');
    if(carEl) carEl.textContent = data._car || '';
    var lowEl = document.getElementById('cvResultLow');
    var highEl = document.getElementById('cvResultHigh');
    if(lowEl) lowEl.textContent = fmt(data.low);
    if(highEl) highEl.textContent = fmt(data.high);

    var midEl = document.getElementById('cvResultMid');
    if(midEl){
      if(instant){ midEl.textContent = fmt(data.mid); }
      else{
        var start = performance.now(), dur = 950, from = 0, to = Number(data.mid) || 0;
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if(reduce){ midEl.textContent = fmt(to); }
        else{
          var tick = function(now){
            var p = Math.min(1, (now - start) / dur);
            var eased = 1 - Math.pow(1 - p, 3);
            midEl.textContent = fmt(Math.round(from + (to - from) * eased));
            if(p < 1) requestAnimationFrame(tick);
          };
          requestAnimationFrame(tick);
        }
      }
    }

    var span = Math.max(1, Number(data.high) - Number(data.low));
    var pos = ((Number(data.mid) - Number(data.low)) / span) * 100;
    pos = Math.max(6, Math.min(94, pos));
    var fill = document.getElementById('cvRangeFill');
    var dot = document.getElementById('cvRangeDot');
    setTimeout(function(){
      if(fill) fill.style.width = pos + '%';
      if(dot) dot.style.insetInlineStart = pos + '%';
    }, instant ? 0 : 80);

    var conf = document.getElementById('cvConf');
    var confText = document.getElementById('cvConfText');
    var lvl = (data.confidence === 'high' || data.confidence === 'low') ? data.confidence : 'medium';
    if(conf) conf.setAttribute('data-level', lvl);
    if(confText) confText.textContent = lvl === 'high' ? t('confHigh') : (lvl === 'low' ? t('confLow') : t('confMedium'));

    var noteEl = document.getElementById('cvResultNote');
    if(noteEl) noteEl.textContent = data.note || '';

    // Currency mark: the Saudi Riyal symbol for SAR, plain text otherwise (SEK).
    var curEl = document.querySelector('.cv-slide[data-step="result"] .cv-cur');
    if(curEl){
      var cur = data.currency || 'SAR';
      if(cur === 'SAR'){ curEl.innerHTML = RIYAL_SVG; }
      else{ curEl.textContent = cur; }
      curEl.setAttribute('aria-label', cur);
    }

    // Keep the section's default (#demo-section on the home page) unless the
    // merchant set a real custom URL in the theme editor.
    var book = document.getElementById('cvBookBtn');
    if(book && CFG.bookUrl && CFG.bookUrl !== '/') book.setAttribute('href', CFG.bookUrl);
  }

  // ---- init ----
  buildMakeGrid();
  buildYearGrid();
  buildCityGrid();
  renderModelChips();
  updateMileageOut();
  setLang(currentLang);
  showStep('intro');
})();
